/**
 * Constants for the application.
 */

// Keys for storing user information in localStorage
export const USER_INFO_STORAGE_KEY = 'userInfo';

// Keys for the order list filter
export const ALL_ORDERS_FILTER = 'all_orders';
export const ALL_SPECIMEN_TYPE_FILTER = 'all_orders_type';

/** Active layout announcements — append when adding a popup; remove when retiring. */
export const LAYOUT_ANNOUNCEMENT_STORAGE_KEYS = [] as const;

/** Prefix for new order signal; per-order key is `${prefix}${orderId}`. */
export const NEW_ORDER_SIGNAL_KEY_PREFIX = 'newOrder:';
